<template lang="pug">
  .page.home
    .intro
      .container
        .left
          christmas-tree(:showTreeLight="showTreeLight"
            :showTreeHelp="showTreeHelp"
            :videos="TOPMANAGER_GREETINGS"
            :gift="GIFT"
            :wishes="USER_GREETINGS"
            @hideTreeLight="showTreeLight=false"
            :key="TOPMANAGER_GREETINGS_length")
        .content
          h2 Зажжём новогоднюю ёлку вместе!
          .swiper-container(ref="wishes")
            .swiper-wrapper
              .swiper-slide(v-for="(wish, key) in USER_GREETINGS" :key="key")
                p(v-html="wish")
          h6 Оставьте свое поздравление коллегам, чтобы зажечь новогодний огонек
          .app-button(@click="showNewWishPopup=true") Написать поздравление
      img.arrow_down(src="@/assets/img/arrow.png" v-scroll-to="'.events'")
    snow-fall
    events(:events="EVENTS")
    transition(name="newWishPopup")
      new-wish-popup(v-if="showNewWishPopup" @close="showNewWishPopup=false" @showTreeLight="showTreeLight=true")
    transition(name="newWishPopup")
      intro-video(v-if="showIntroVideo" @close="showIntroVideo=false")
</template>

<script>

import Events from "@/components/Events";
import NewWishPopup from "@/components/NewWishPopup";
import ChristmasTree from "@/components/ChristmasTree";
import SnowFall from "@/components/SnowFall";
import IntroVideo from "@/components/IntroVideo";

export default {
  name: 'Home',
  components: {IntroVideo, SnowFall, ChristmasTree, NewWishPopup, Events},
  data: () => ({
    showIntroVideo: false,
    showNewWishPopup: false,
    showTreeLight: false,
    showTreeHelp: false,

    EVENTS: [],
    GIFT: '',
    TOPMANAGER_GREETINGS: [],
    USER_GREETINGS: [],
  }),
  computed: {
    TOPMANAGER_GREETINGS_length() {
      return this.TOPMANAGER_GREETINGS?.length;
    }
  },
  methods: {
    initIntroSlider() {
      new Swiper(this.$refs['wishes'], {
        grabCursor: true,
        direction: 'vertical',
        slidesPerView: 3,
        loop: true,
        spaceBetween: 15,
        speed: 500,
        autoplay: {
          delay: 2000,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            speed: 1000,
          }
        }
      });
    },
    async fetchEventsNewyear() {
      try {
        let {data} = await this.axios.get('?ACTION=getEventsNewyear',);
        if (data.DATA) {
          this.TOPMANAGER_GREETINGS = data.DATA.TOPMANAGER_GREETINGS;
          this.EVENTS = data.DATA.EVENTS;
          this.GIFT = data.DATA.GIFT;
          this.USER_GREETINGS = data.DATA.USER_GREETINGS;
          this.$nextTick(this.initIntroSlider)
        }
      } catch (e) {
        console.log(e);
      }
    },
    checkShowIntroVideo() {
      if (!window.sessionStorage.getItem('introVideoShowed')) {
        this.showIntroVideo = true;
        this.$watch('showIntroVideo', ()=> {
          this.showTreeHelp = true;
          setInterval(()=>{
            this.showTreeHelp = false;
          }, 5500)
        })
      }
    }
  },
  created() {
    this.checkShowIntroVideo();
  },
  mounted() {
    this.fetchEventsNewyear();
  },
}
</script>
<style scoped lang="scss">
.home {
  overflow-x: hidden;
  position: relative;
  background: url(../assets/img/intro_bg_trees_left.png) no-repeat left 22rem / 50% auto,
  url(../assets/img/intro_bg_trees_right.png) no-repeat right 22rem / 50% auto,
  url(../assets/img/intro_bg.png) no-repeat center top -5rem / 100% auto,
  url(../assets/img/intro_bg_bottom_snow.png) no-repeat center 89.5rem / 100% auto,
  url(../assets/img/intro_bg_bottom_trees.png) no-repeat center bottom / 100% auto #1d336f;
}

.intro {
  position: relative;

  .container {
    display: flex;
    justify-content: space-between;
  }

  .left {
    position: relative;
    width: calc(100% - 44.5rem);

    &::v-deep .christmasTree {
      position: absolute;
      left: 55.5%;
      top: 60%;
      transform: translate(-50%, -50%);
    }
  }

  .content {
    position: relative;
    z-index: 1;
    padding-top: 8.3rem;
    padding-bottom: 10.2rem;
    width: 44.5rem;
    max-width: 100%;

    h2 {
      position: relative;
      z-index: 2;
      padding-left: 0.8rem;
      max-width: 26rem;
      font-size: 4rem;
      font-weight: bold;
    }

    .swiper-container {
      height: to_rem(474px);
      margin: -1.5rem 0 0 -3rem;
      padding-left: 3rem;
      -webkit-mask-image: -webkit-linear-gradient(top, rgba(0, 0, 0, 0) 15%, #000 40%, #000 60%, rgba(0, 0, 0, 0) 85%);
    }

    .swiper-slide {
      position: relative;

      display: flex;
      flex-direction: column;
      justify-content: space-between;

      width: 34.3rem;
      padding: 1.6rem 1.6rem 1.5rem 2rem;


      background: rgba(#034aa9, 0.7);

      &:after {
        content: '';
        display: block;
        position: absolute;
        border: 1.1rem solid #034aa9;
        opacity: 0.7;
      }

      & {
        border-radius: 2rem 0 2rem 2rem;

        &:after {
          top: 0;
          left: 100%;
          border-right-color: transparent;
          border-bottom-color: transparent;
        }
      }

      /*
              &:nth-of-type(odd) {
                border-radius: 0 2rem 2rem 2rem;
                &:after {
                  top: 0;
                  right: 100%;
                  border-left-color: transparent;
                  border-bottom-color: transparent;
                }
              }*/

      p {
        line-height: 1.2;
        text-align: justify;
      }
    }

    h6 {
      position: relative;
      z-index: 1;
      margin-top: -1rem;
      margin-bottom: 1.5rem;
      font-size: to_rem(18px);
    }
  }

  .arrow_down {
    position: absolute;
    bottom: 1.2rem;
    left: 50%;
    transform: translateX(-50%);
    width: 4rem;
    cursor: pointer;
  }

}

@include mobile_or_P {
  .home {
    background: url(../assets/img/intro_bg_trees_left.png) no-repeat left -3rem top 44rem / 95% auto,
    url(../assets/img/intro_bg_trees_right.png) no-repeat right -4rem top 44rem / 95% auto,
    url(../assets/img/intro_bg.png) no-repeat left -9.8rem top -4.1rem / 219% auto,
    url(../assets/img/intro_bg_bottom_snow.png) no-repeat center 87.5rem / 100% auto,
    url(../assets/img/intro_bg_bottom_trees.png) no-repeat left 55% bottom -1rem/220% auto #1d336f;
  }
  .intro {
    .container {
      flex-direction: column;
      justify-content: flex-start;
    }

    .left {
      height: 35.5rem;
      width: 100%;

      &::v-deep .christmasTree {
        left: 39.5%;
        top: 61%;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding-top: 0;
      padding-bottom: 7.7rem;

      h2 {
        margin-bottom: 1.6rem;
        padding-left: 0;
        font-size: 2.25rem;
        text-align: center;
      }

      .swiper-container {
        width: 100vmin;
        height: 7rem;
        margin: 0 -1.3rem 1rem -1.3rem;
        padding: 0 2rem;
        -webkit-mask-image: none;
      }

      .swiper-slide {
        width: 100%;
        padding: 1.2rem 1.4rem 1.1rem 1.3rem;

        &:after {
          border-width: 0.75rem;
        }

        p {
          font-size: 0.76rem;
          line-height: 1.3;
        }
      }

      h6 {
        max-width: 75%;
        margin: 0 0 1.3rem;
        font-size: 1.03rem;
        line-height: 1.3;
        text-align: center;
      }
    }

    .arrow_down {
      bottom: 2rem;
    }
  }
}
@media screen and (max-width: 900px) and (orientation: landscape) {
  .home {
    background: url(../assets/img/intro_bg_trees_left.png) no-repeat left -3rem top 44rem/95% auto,
    url(../assets/img/intro_bg_trees_right.png) no-repeat right -4rem top 44rem/95% auto,
    url(../assets/img/intro_bg.png) no-repeat left -3.5rem top -5rem/138% auto,
    url(../assets/img/intro_bg_bottom_snow.png) no-repeat center 66.5rem/100% auto,
    url(../assets/img/intro_bg_bottom_trees.png) no-repeat left 55% bottom -1rem/220% auto #1d336f;
  }
}

.newWishPopup {
  &-enter {

  }

  &-enter-active {

  }

  &-leave-active {
    opacity: 0;
    transition: .3s;
  }
}
</style>
